import { render } from "./LessonPlanner.vue?vue&type=template&id=5c8e0f8b"
import script from "./LessonPlanner.vue?vue&type=script&lang=js"
export * from "./LessonPlanner.vue?vue&type=script&lang=js"

import "./LessonPlanner.vue?vue&type=style&index=0&id=5c8e0f8b&lang=scss&scopped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__